import { useQuery } from '@tanstack/react-query';
import {
  EXCLUDE_WC_RULE_RESULT_QUERY_KEY,
  SUBMISSION_PRICE_QUERY_KEY,
  SUBMISSION_QUERY_KEY,
  UNDERWRITING_QUESTIONS_QUERY_KEY,
} from './submission.constants';
import {
  excludeWcRuleResult,
  fetchSubmissionPrice,
  fetchUnderwritingQuestions,
  getSubmission,
} from './submission.requests';
import type { ISubmissionPriceQueries } from './submission.types';

export const useUnderwritingQuestions = (id: string, enabled = true) =>
  useQuery({
    queryKey: [UNDERWRITING_QUESTIONS_QUERY_KEY, id],
    queryFn: () => fetchUnderwritingQuestions(id),
    enabled,
  });

export const useSubmission = (id: string, enabled = true) =>
  useQuery({
    queryKey: [SUBMISSION_QUERY_KEY, id],
    queryFn: () => getSubmission(id),
    retry: 0,
    enabled,
  });

export const useSubmissionPrice = (
  id: string,
  query?: ISubmissionPriceQueries,
  options?: { enabled?: boolean },
) =>
  useQuery({
    queryKey: [SUBMISSION_PRICE_QUERY_KEY, id, query],
    queryFn: () => fetchSubmissionPrice(id, query),
    staleTime: 0,
    retry: 1,
    retryDelay: () => 3000,
    enabled: options?.enabled ?? true,
  });

export const useExcludeWcRuleResult = (submissionId: string, enabled = true) =>
  useQuery({
    queryKey: [EXCLUDE_WC_RULE_RESULT_QUERY_KEY, submissionId],
    queryFn: () => excludeWcRuleResult(submissionId),
    enabled,
  });
